<ng-container *notInPopulation="[population.Kids]">
  <div class="d-lg-block d-none">
    <fgb-page-header
      [pageTitle]="'earn.page.title'"
      [showBalance]="false"
      [backButtonLink]="'/'"
    ></fgb-page-header>
  </div>
</ng-container>
<div class="d-lg-none d-block">
  <fgb-page-header
    [pageTitle]="'earn.page.title'"
    [showBalance]="false"
    [backButtonLink]="'/'"
    [showBanner]="false"
  ></fgb-page-header>
</div>

<div class="container">
  <fgbcl-earn-points [lgWidth]="'6'"></fgbcl-earn-points>
</div>
